import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';

const styles = (theme:Theme):any => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    //width: 200,
  },
  hide:{
    display:'none',
  },
});

class FNumberField extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      next: true,
      value: props.value&&+props.value
    };
  }

  handleChange = (event:any) => {
    const {onChange} = this.props;
    let value = event.target.value;
    this.setState({value});
    if(typeof onChange === 'function') console.log('final onChange is a function',value);
    //if(typeof onChange === 'function')
    if(typeof onChange === 'function') onChange(value);
  };

  render() {
    const {id,label,divider,classes } = this.props;

    return (
      <div className={classes.root}>
        <TextField
            label={label}
            id={id}
            name={id}
            type={'text'}
            margin='dense'
            fullWidth={true}
            className={classes.textField}
            value={this.state.value}
            onChange={this.handleChange}
          />
        {divider && <Divider />}
      </div>
    );
  }
}

FNumberField.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default withStyles(styles)(FNumberField);
